// Shared hook — fetches the parent's children once and keeps the
// selected child in sync across Report Card, Attendance, Payments pages.

import { useState, useEffect } from 'react';
import api from '../api/axios';

export function useMyChildren() {
  const [children, setChildren] = useState([]);
  const [selectedChild, setSelectedChild] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    api.get('/parent-students/my-children')
      .then(res => {
        const list = res.data || [];
        setChildren(list);
        if (list.length > 0) setSelectedChild(list[0]);
      })
      .catch(err => {
        setError(err.response?.data?.detail || err.message);
      })
      .finally(() => setLoading(false));
  }, []);

  return { children, selectedChild, setSelectedChild, loading, error };
}